<div class="sidebar-area bg-white" [ngClass]="{ active: isSidebarToggled }"
    [class.component-dark-theme]="themeService.isDark()" [class.dark-sidebar]="themeService.isSidebarDark()"
    [class.right-sidebar]="themeService.isRightSidebar()" [class.hide-sidebar]="themeService.isHideSidebar()"
    [class.card-borderd-theme]="themeService.isCardBorder()" [class.rtl-enabled]="themeService.isRTLEnabled()">
    <div class="logo bg-white">
        <a routerLink="/department/dashboard" class="d-flex align-items-center">
            <img src="assets/images/sidebar-logo.png" alt="logo-icon">
            <span class="fw-semibold">Amakalakara</span>
        </a>
    </div>
    <!-- Close control. d-xl-none matches the header's burger, which is also
         hidden from xl up: below xl the sidebar slides over the page and
         covers that burger, so without this there is no way to close it
         again. From xl up the sidebar is permanent and needs no close. -->
    <div (click)="toggleSidebar()" class="burger-menu d-xl-none" [ngClass]="{'active': isSidebarToggled}" role="button"
        tabindex="0" aria-label="Close menu" (keydown.enter)="toggleSidebar()" (keydown.space)="toggleSidebar()">
        <span class="top-bar"></span>
        <span class="middle-bar"></span>
        <span class="bottom-bar"></span>
    </div>


    <ng-scrollbar visibility="hover">
        <div class="sidebar-inner">
            <div class="sidebar-menu">
                <mat-accordion>
                    <ng-container *ngFor="let item of menuItems">
                        <!-- Single menu item (no children) -->

                        <mat-panel-title>
                            <a *ngIf="!item.children" [routerLink]="item.route" class="sidebar-menu-link"
                                routerLinkActive="active">
                                <i class="material-symbols-outlined" *ngIf="item.icon">
                                    {{ item.icon }}
                                </i>
                                <span class="title">
                                    {{ item.title }}
                                </span>
                            </a>
                        </mat-panel-title>
                        <!-- Menu item with children (expandable) -->
                        <mat-expansion-panel *ngIf="item.children"
                            [expanded]="isActive(item) || item.title === 'Registration'">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <i class="material-symbols-outlined" *ngIf="item.icon">
                                        {{ item.icon }}
                                    </i>
                                    <span class="title">
                                        {{ item.title }}
                                    </span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <ul class="sidebar-sub-menu">
                                <li class="sidemenu-item" *ngFor="let subItem of item.children">
                                    <a [routerLink]="subItem.route" *ngIf="canShowSubItem(subItem)"
                                        [queryParams]="subItem.queryParams" routerLinkActive="active"
                                        class="sidemenu-link">
                                        {{ subItem.title }}
                                    </a>
                                </li>
                            </ul>
                        </mat-expansion-panel>
                    </ng-container>
                </mat-accordion>
            </div>
        </div>
    </ng-scrollbar>
</div>